// extracted by mini-css-extract-plugin
export default {"focusable":"styles_focusable__i7+zW","spatialActive":"styles_spatialActive__2rbSV"};